import { render, staticRenderFns } from "./current-task-table.vue?vue&type=template&id=9194b34e&scoped=true&"
import script from "./current-task-table.vue?vue&type=script&lang=js&"
export * from "./current-task-table.vue?vue&type=script&lang=js&"
import style0 from "./current-task-table.vue?vue&type=style&index=0&id=9194b34e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9194b34e",
  null
  
)

export default component.exports